import type { AccessResource } from '../../../../main/types/accessControlTypes';
import { WRITE_PERMISSION } from '../../../support/accessControlConstants';

export const ACCESS_COMPONENT_DEFAULT_PROPS: { accessResources: AccessResource[]; permission: number } = {
  accessResources: ['channel_level_settings'],
  permission: WRITE_PERMISSION,
};
